export default __webpack_public_path__ + "static/media/sputnik.ff221b40.png";